<template>
  <div>
    <h1>PRODUCTs</h1>
  <!-- <ol>
    <li v-for="product in products" v-bind:key="product.index">
      {{product.index}} {{product.displayName}} - {{product.quantity}}
    </li>
  </ol> -->

Add a product to cart.
<form @submit.prevent="addItemToCart">
  <label>
    ProductId: <input type="text" v-model="myProduct.productId">
  </label>
  <label>
    skuId: <input type="text" v-model="myProduct.skuId">
  </label>
  <label>
    Quantity: <input type="number" v-model.number="myProduct.quantity">
  </label>
  <button>Add</button>
</form>

  </div>
</template>

<script>
export default {
  name: 'ProductList',
  data () {
    return {
      myProduct: {
        productId: '6456',
        skuId: '61678',
        quantity: 1,
        note: ''
      }
    }
  },
  methods: {
    addItemToCart: function () {
      this.$store.dispatch('cart/ADD_ITEM_TO_BUCKET', this.myProduct)
    }
  },
  computed: {
    // products () {
    //   return store.state.cart.products
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label{display: block}
</style>
